import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosInstance";
import "./AdminDashboard.css";

export default function AdminDashboard() {
  const [reservations, setReservations] = useState([]);
  const [blockedTimes, setBlockedTimes] = useState([]);
  const [specialOpenDays, setSpecialOpenDays] = useState([]);
  const [newBlocked, setNewBlocked] = useState({ date: "", startTime: "", endTime: "" });
  const [newOpenMonday, setNewOpenMonday] = useState("");

  const navigate = useNavigate();
  const token = localStorage.getItem("adminToken");

  const fetchReservations = async () => {
    const { data } = await api.get("/reservations", { headers: { Authorization: `Bearer ${token}` } });
    setReservations(data);
  };

  const fetchBlockedTimes = async () => {
    const { data } = await api.get("/admin/blocked-times", { headers: { Authorization: `Bearer ${token}` } });
    setBlockedTimes(data);
  };

  const fetchSpecialOpenDays = async () => {
    const { data } = await api.get("/admin/special-open", { headers: { Authorization: `Bearer ${token}` } });
    setSpecialOpenDays(data);
  };

  useEffect(() => {
    if (!token) navigate("/admin");
    else {
      fetchReservations();
      fetchBlockedTimes();
      fetchSpecialOpenDays();
    }
  }, [token, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/admin");
  };

  const deleteReservation = async (id) => {
    await api.delete(`/reservations/${id}`, { headers: { Authorization: `Bearer ${token}` } });
    fetchReservations();
  };

  const addBlockedTime = async () => {
    await api.post("/admin/blocked-times", newBlocked, { headers: { Authorization: `Bearer ${token}` } });
    setNewBlocked({ date: "", startTime: "", endTime: "" });
    fetchBlockedTimes();
  };

  const deleteBlockedTime = async (id) => {
    await api.delete(`/admin/blocked-times/${id}`, { headers: { Authorization: `Bearer ${token}` } });
    fetchBlockedTimes();
  };

  const addSpecialMonday = async () => {
    if (!newOpenMonday) return;
    await api.post("/admin/special-open", { date: newOpenMonday }, { headers: { Authorization: `Bearer ${token}` } });
    setNewOpenMonday("");
    fetchSpecialOpenDays();
  };

  const deleteSpecialMonday = async (id) => {
    await api.delete(`/admin/special-open/${id}`, { headers: { Authorization: `Bearer ${token}` } });
    fetchSpecialOpenDays();
  };

  return (
    <div className="admin-dashboard">
      <header className="dashboard-header">
        <h1>Admin Dashboard</h1>
        <div className="header-buttons">
          <button onClick={() => navigate("/admin/menu")} className="menu-btn">Admin Menu</button>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </header>

      <section className="dashboard-section">
        <h2>Reservations</h2>

        {/* Desktop Table (scrollable wrapper) */}
        <div className="reservations-scroll-container desktop-view">
          <div className="reservations-table-wrapper">
            <table className="styled-table desktop-table">
              <thead>
                <tr>
                  <th>Name</th><th>Email</th><th>Phone</th><th>Date</th><th>Time</th><th>Guests</th><th>Note</th><th>Action</th>
                </tr>
              </thead>
              <tbody>
                {reservations.map(r => (
                  <tr key={r._id}>
                    <td>{r.name}</td>
                    <td>{r.email}</td>
                    <td>{r.phone}</td>
                    <td>{new Date(new Date(r.date).getTime() + 86400000).toLocaleDateString()}</td>
                    <td>{r.time}</td>
                    <td>{r.guests}</td>
                    <td>{r.note || "-"}</td>
                    <td><button onClick={() => deleteReservation(r._id)}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile Cards (with scroll) */}
        <div className="reservations-scroll-container mobile-view">
          <div className="reservation-cards">
            {reservations.map(r => (
              <div className="reservation-card" key={r._id}>
                <div><strong>Name:</strong> <span>{r.name}</span></div>
                <div><strong>Email:</strong> <span>{r.email}</span></div>
                <div><strong>Phone:</strong> <span>{r.phone}</span></div>
                <div><strong>Date:</strong> <span>{new Date(new Date(r.date).getTime() + 86400000).toLocaleDateString()}</span></div>
                <div><strong>Time:</strong> <span>{r.time}</span></div>
                <div><strong>Guests:</strong> <span>{r.guests}</span></div>
                <div><strong>Note:</strong> <span>{r.note || "-"}</span></div> {/* ✅ new */}
                <button onClick={() => deleteReservation(r._id)}>Delete</button>
              </div>
            ))}
          </div>
        </div>
      </section>



      <section className="dashboard-section">
        <h2>Blocked Times</h2>

        <div className="form-inline">
          <input type="date" value={newBlocked.date} onChange={e => setNewBlocked({...newBlocked, date: e.target.value})} />
          <input type="time" value={newBlocked.startTime} onChange={e => setNewBlocked({...newBlocked, startTime: e.target.value})} />
          <input type="time" value={newBlocked.endTime} onChange={e => setNewBlocked({...newBlocked, endTime: e.target.value})} />
          <button onClick={addBlockedTime}>Add</button>
        </div>

        <ul>
          {blockedTimes.map(b => (
            <li key={b._id}>
              Date: {new Date(new Date(b.date).getTime() + 86400000).toLocaleDateString()}, {b.startTime} - {b.endTime} 
              <button onClick={() => deleteBlockedTime(b._id)}>Delete</button>
            </li>
          ))}
        </ul>
      </section>

      <section className="dashboard-section">
        <h2>Special Open Mondays</h2>
        <div className="form-inline">
          <input type="date" value={newOpenMonday} onChange={e => setNewOpenMonday(e.target.value)} />
          <button onClick={addSpecialMonday}>Add</button>
        </div>
        <ul>
          {specialOpenDays.map(d => (
            <li key={d._id}>
              {new Date(new Date(d.date).getTime() + 86400000).toLocaleDateString()} 
              <button onClick={() => deleteSpecialMonday(d._id)}>Delete</button>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
